import LecomReflux from '../../reflux/lecom_reflux';
import LecomRefluxActons from '../../reflux/lecom_reflux_actions';
import BaseReflux from '../../reflux/base_reflux';

import { generateUUID } from '../../utils/uuid';
import FlashMessagesStoreItem from '../models/flash_messages_store_item';
import { FlashMessagesEventHandler, FlashMessagesEvents } from '../events/flash_messages_event_handler';

import FlashMessagesTypes from '../constants/flash_messages_types';

export const FLASH_MESSAGE_DISMISS_TIMEOUT = 5000;

export const FlashMessagesActions = Reflux.createActions([
	'clear',
	'addMessage',
	'addMessageIfNotExists',
	'removeMessage'
].concat(LecomRefluxActons));

export const FlashMessagesStore = Reflux.createStore(Object.assign(BaseReflux, {
	listenables: FlashMessagesActions,
	storeItemClass: FlashMessagesStoreItem,
	eventHandler: FlashMessagesEventHandler,
	events: FlashMessagesEvents,
	store: {},

	onInit(props) {
		this.store[props.id] = props;
	},

	onClear(itemId) {
		this._setProperties(itemId, this.store[itemId], { messages: [] }, true)
	},
	
	onAddMessageIfNotExists(itemId, newMessage) {
		let _messages = this.store[itemId]["messages"];
		const messageToRemoveIndex = _messages.findIndex((item) => item.message == newMessage.message);
		if (messageToRemoveIndex === -1){
			this.onAddMessage(itemId, newMessage);
			return true;
		}
		return false;
	},

	onAddMessage(itemId, message) {		
		const newMessage = this.buildMessageObject(message);
		const _messages = this.store[itemId] && this.store[itemId]["messages"] ? this.store[itemId]["messages"] : [];

		_messages.push(newMessage);

		this.onSetState(itemId);

		// FlashMessagesEventHandler.publish(FlashMessagesEvents.MESSAGE_ADDED, message);
	},

	onRemoveMessage(itemId, messageId) {
		let _messages = this.store[itemId]["messages"];
		const messageToRemoveIndex = _messages.findIndex((message) => message.id == messageId);

		if (messageToRemoveIndex === -1){
			// throw new Error(`Not a message with a id: ${messageId}`);
			return;
		}

		_messages.splice(messageToRemoveIndex, 1);

		this.onSetState(itemId);

		// FlashMessagesEventHandler.publish(FlashMessagesEvents.MESSAGE_REMOVED, messageId);
	},

	buildMessageObject(originalMessage) {
		if (typeof originalMessage === undefined) throw new Error("Insert a message!");

		if (typeof originalMessage === 'string') {
			originalMessage = {
				type:  FlashMessagesTypes.SUCCESS,
				message: originalMessage
			};
		} else if (typeof originalMessage !== 'object' || Array.isArray(originalMessage)) {
			throw new Error("Insert a valid message");
		} if (typeof originalMessage === 'object') {
			if (!originalMessage.hasOwnProperty("message")) throw new Error("Insert message in a object with a prop 'message'!");
			if (!originalMessage.hasOwnProperty("type")) originalMessage.type = FlashMessagesTypes.SUCCESS;
		}

		if ( Object.keys(FlashMessagesTypes).map(messageType => FlashMessagesTypes[messageType]).indexOf(originalMessage.type) === -1)
			throw new Error("Message type is not valid");

		if(originalMessage.haveDismissTimeout) {
			originalMessage.dismissTimeout = FLASH_MESSAGE_DISMISS_TIMEOUT;
		}

		return Object.assign({ id: generateUUID() }, originalMessage);
	},

	_resetStore() {
		this.store = {}
	}

}));
